import * as React from "react";
import type { SVGProps } from "react";
const SvgSunny = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M13 2v3h-2V2zm-1 7a3 3 0 0 0-3 3c0 .144.05.427.134.753a1 1 0 1 1-1.938.494C7.11 12.917 7 12.418 7 12a5 5 0 1 1 3.696 4.828 1 1 0 0 1 .52-1.931q.376.102.784.103a3 3 0 1 0 0-6m1 11v-1h-2v3h2v-2m9-7h-3v-2h3zM4 13h1v-2H2v2h2m15.779-7.364-.708.707-.707.707-.707.707-1.414-1.414.707-.707.707-.707.707-.707zM7.049 18.364l.708-.707-1.414-1.414-.707.707-.707.707-.708.707 1.415 1.414.707-.707zM5.637 4.222l.707.707.707.707.707.707-1.414 1.414-.707-.707-.707-.707-.707-.707zM18.364 16.95l-.707-.707-1.414 1.414.707.707.707.707.707.707 1.415-1.414-.708-.707z"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgSunny;
